const notificationTypes = {
	'order-info': "Ödeme Bildirimi",
	'sms-code': "Doğrulama Kodu",
	'payment-refund': "İade Bildirimi",
}

export default notificationTypes